import { Box, Grid, Typography, Link } from "@mui/material";
import React, { useEffect, useState } from "react";
import { CustomPrimaryButtonFixed } from "src/components/uiElements/buttons/primaryButtonFixed";
import SignInScreen from "../signin/signInScreen";

const PasswordResetSuccessScreen = () => {
  const [isSignInOpen, setIsSignInOpen] = useState(false);
  const [isResetPasswordSuccess, setResetPasswordSuccess] = useState(false);

  const handleSignInOpen = () => {
    setIsSignInOpen(true);
    setResetPasswordSuccess(true);
  };

  return (
    <>
      {!isResetPasswordSuccess && (
        <Box
          sx={{
            marginRight: "15%",
            marginLeft: "15%",
            marginTop: "7%",
            position: "relative",
          }}
        >
          <Grid
            container
            spacing={0}
            direction="column"
            alignItems="end"
            justifyContent="end"
            sx={{ marginTop: "15px" }}
          >
            <Grid item xs={3}>
              <Box sx={{ marginTop: '30px', }}>
                <Box>
                  <Box sx={{ textAlign: "center" }}>
                    <img
                      src="/logo_b.png"
                      style={{ display: "inline" }}
                    />
                  </Box>
                  <Typography
                    variant="h5"
                    sx={{
                      color: "#000000",
                      textTransform: "uppercase",
                      fontWeight: "700",
                      fontSize: "22px",
                      textAlign: "center",
                      marginTop: "14px",
                      marginBottom: "14px",
                    }}
                  >
                    Password Reset
                  </Typography>

                  <Grid
                    container
                    spacing={1}
                    sx={{
                      justifyContent: "center",
                    }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      xl={12}
                      sx={{ textAlign: "center", marginTop: "20px" }}
                    >
                      <Typography sx={{ color: '#000000' }}>
                        Your Password has been reset Successfully
                      </Typography>
                    </Grid>

                    <Grid
                      item
                      xs={12}
                      style={{ textAlign: 'center', }}
                      sx={{ mt: "14px" }}
                    >
                      <Typography sx={{ color: '#6A0DAD', fontWeight: '300', cursor: 'pointer', textDecoration: 'underline','&:hover': { textDecoration: 'none' } }} onClick={handleSignInOpen}>
                        SignIn
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
      )}


      {isSignInOpen && <SignInScreen />}
    </>
  );
};

export default PasswordResetSuccessScreen;
